var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtitleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 0H1.375C0.615 0 0 0.615 0 1.375V6.375C0 7.135 0.615 7.75 1.375 7.75H8.375C9.135 7.75 9.75 7.135 9.75 6.375V1.375C9.75 0.615 9.135 0 8.375 0ZM9 6.375C9 6.72 8.72 7 8.375 7H1.375C1.03 7 0.75 6.72 0.75 6.375V1.375C0.75 1.03 1.03 0.75 1.375 0.75H8.375C8.72 0.75 9 1.03 9 1.375V6.375Z",
    fill: "#FED71F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 5H1.875C1.67 5 1.5 5.17 1.5 5.375C1.5 5.58 1.67 5.75 1.875 5.75H4.875C5.08 5.75 5.25 5.58 5.25 5.375C5.25 5.17 5.08 5 4.875 5Z",
    fill: "#FED71F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 5H6.375C6.17 5 6 5.17 6 5.375C6 5.58 6.17 5.75 6.375 5.75H7.875C8.08 5.75 8.25 5.58 8.25 5.375C8.25 5.17 8.08 5 7.875 5Z",
    fill: "#FED71F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 4.25H2.875C3.08 4.25 3.25 4.08 3.25 3.875C3.25 3.67 3.08 3.5 2.875 3.5H1.875C1.67 3.5 1.5 3.67 1.5 3.875C1.5 4.08 1.67 4.25 1.875 4.25Z",
    fill: "#FED71F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 3.5H4.375C4.17 3.5 4 3.67 4 3.875C4 4.08 4.17 4.25 4.375 4.25H7.875C8.08 4.25 8.25 4.08 8.25 3.875C8.25 3.67 8.08 3.5 7.875 3.5Z",
    fill: "#FED71F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitleIcon);
export default __webpack_public_path__ + "static/media/subtitle-icon.35b052f5864f23a6dcc3769ddb599167.svg";
export { ForwardRef as ReactComponent };